module.exports = __webpack_public_path__ + "img/calogero.0d302e0f.jpg";